import { z } from 'zod';

const envSchema = z.object({
  VITE_AUTH0_DOMAIN: z.string(),
  VITE_AUTH0_CLIENT_ID: z.string(),
  VITE_AUTH0_AUDIENCE: z.string(),
  VITE_GRAPHQL_URL: z.string(),
  VITE_REST_BASE_URL: z.string(),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_SPONSOR_MODE: z.string().optional(),
});

const env = envSchema.parse(import.meta.env);

export const AUTH0_DOMAIN = env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = env.VITE_AUTH0_AUDIENCE;
export const GRAPHQL_URL = env.VITE_GRAPHQL_URL;
export const REST_BASE_URL = env.VITE_REST_BASE_URL;
export const SENTRY_DSN = env.VITE_SENTRY_DSN ?? '';
export const SPONSOR_MODE = env.VITE_SPONSOR_MODE === 'true';
